@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.label {
	color: Colors.$col-greyFontLight;
	padding: Constants.$val-spacing-s;
	padding-left: 0;
	padding-top: Constants.$val-spacing-l;
}

.value {
	padding-left: Constants.$val-spacing-s;
	padding-top: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-l;
}

.grey-text {
	color: Colors.$col-greyFontLight;
}

.valid-cell-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 5px;
}

.link {
	font-size: Constants.$val-fontSizeXBig;
	color: Colors.$col-blue;
}

.reason {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.table-box {
	background-color: white;
	padding-top: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-s;
	box-shadow: 0 2px 2px Colors.$col-greyConnection;
}

.table-box-header {
	color: Colors.$col-greyFontLight;
	font-size: Constants.$val-fontSizeBig;
	padding: Constants.$val-spacing-s;
}

.table {
	height:min-content;
}

.model-label {
	background-color: white;
	width: 100%;
	padding: Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-m;
	margin-bottom: Constants.$val-spacing-s;
	box-shadow: 0 2px 2px Colors.$col-greyConnection;
	display: flex;
	justify-content: space-between;
}

.model-number {
	margin-top: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeBig;
	font-weight: bold;
	text-transform: uppercase;
}

.serial-number {
	margin-top: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeBig;
	font-weight: bold;
	text-transform: uppercase;
	color: Colors.$col-design-grey10;
}

.radio-buttons {
	margin-top: 10px;
	margin-bottom: 10px;
}

.status-icon {
	padding-right: 5px;
	padding-bottom: Constants.$val-spacing-xs;
}

.title {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
}

.modal-title{
	font-weight: bold;
}

.asterisk {
	color: Colors.$col-orangeBorder;
}

.required-label {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xs;
}